import { unary_numeric_expression } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class unary_function_call extends unary_numeric_expression {
    get type() {
        return EntityTypesAP214.UNARY_FUNCTION_CALL;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
unary_function_call.query = [EntityTypesAP214.ABS_FUNCTION, EntityTypesAP214.MINUS_FUNCTION, EntityTypesAP214.SIN_FUNCTION, EntityTypesAP214.COS_FUNCTION, EntityTypesAP214.TAN_FUNCTION, EntityTypesAP214.ASIN_FUNCTION, EntityTypesAP214.ACOS_FUNCTION, EntityTypesAP214.EXP_FUNCTION, EntityTypesAP214.LOG_FUNCTION, EntityTypesAP214.LOG2_FUNCTION, EntityTypesAP214.LOG10_FUNCTION, EntityTypesAP214.SQUARE_ROOT_FUNCTION];
unary_function_call.expectedType = EntityTypesAP214.UNARY_FUNCTION_CALL;
